import { render } from "./DiskInfo.vue?vue&type=template&id=4722272a&ts=true"
import script from "./DiskInfo.vue?vue&type=script&lang=ts"
export * from "./DiskInfo.vue?vue&type=script&lang=ts"

import "./DiskInfo.vue?vue&type=style&index=0&id=4722272a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__